(function () {
    'use strict';

    angular.module("imApp").factory("deliveryCustomerService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 1074,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 1075,
                    parameters: edit
                });
            },
            deleteItem: function (edit) {
                return $ihttp.post({
                    method: 2580,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
